/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useRef } from 'react';
import styled from 'styled-components';
import { Button } from 'components';
import { DownArrow as Arrow } from 'assets/svgs/';

function QuantityInput({ quantity, setQuantity, callback }) {
  const quantityInputRef = useRef();

  const handleKeyDown = (event) => {
    event.persist();
    return ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.code)
      ? true
      : !isNaN(Number(event.key)) && event.code !== 'Space';
  };

  const handleChange = (event) => {
    event.persist();
    const { value } = event.target;
    const _quantity = value ? parseInt(value, 10) : '';
    if (_quantity !== 0) {
      setQuantity(_quantity);
      if (callback && _quantity !== '') {
        callback(_quantity);
      }
    }
  };

  const handleBlur = (e) => {
    if (e.target.value === '') {
      setQuantity(1);
      if (callback) {
        callback(1);
      }
    }
  };

  return (
    <Container disabled={!quantity}>
      <Button
        disabled={!quantity}
        onClick={() => {
          let newQuantity;
          setQuantity((currentQuantity) => {
            newQuantity = currentQuantity + 1;
            return newQuantity;
          });
          if (callback) {
            callback(newQuantity);
          }
        }}>
        <Arrow />
      </Button>
      <Button
        disabled={!quantity}
        onClick={() => {
          let newQuantity;
          if (quantity && quantity > 1) {
            setQuantity((currentQuantity) => {
              newQuantity = currentQuantity - 1;
              return newQuantity;
            });
          }
          if (callback && newQuantity) {
            callback(newQuantity);
          }
        }}>
        <Arrow />
      </Button>
      <input
        ref={quantityInputRef}
        name="quantity"
        type="number"
        inputMode="numeric"
        pattern="[0-9]*"
        value={quantity}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </Container>
  );
}

const Container = styled.div`
  display: inline-block;
  margin-bottom: 1.6rem;
  margin-top: 0.1875rem;
  position: relative;

  @media (width >= 900px) {
    margin-bottom: 3rem;
  }

  button {
    border: 2px solid var(--connolly-red);
    height: 0.8125rem;
    position: absolute;
    min-width: unset;
    padding: unset;
    width: 1.875rem;

    svg {
      width: 0.725rem;
    }

    &:nth-of-type(1) {
      border-bottom-width: 0;
      border-radius: 0.375rem 0.375rem 0 0;
      padding-top: 0.15rem;
      top: 0;

      svg {
        transform: rotate(180deg);
      }
    }

    &:nth-of-type(2) {
      border-top-width: 0;
      border-radius: 0 0 0.375rem 0.375rem;
      bottom: 0;
      padding-bottom: 0.15rem;
    }
  }

  input {
    background-color: transparent;
    border: 0.0625em solid var(--connolly-red);
    border-radius: 0.375em;
    color: var(--connolly-black);
    font-family: 'Open Sans', 'Segoe UI', Tahoma, sans-serif;
    font-size: 1rem;
    font-weight: 700;
    height: 1.625em;
    outline: none;
    padding-left: 2.25em;
    width: 70px;

    &:focus {
      border: 0.125em solid var(--connolly-red);
    }

    /* These styles hide the native arrows on the number input type */

    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      appearance: none;
      margin: 0;
    }

    /* Firefox */
    &[type='number'] {
      appearance: textfield;
    }
  }
`;

export default QuantityInput;
